var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-template-component',[_c('span',[_c('h1',[_vm._v("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }